module.exports = __webpack_public_path__ + "img/big_11B05_blue.9dcd42a2.png";